



























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import MailingsMessageDetails from "./MailingsMessageDetails.vue";

import MailingMessageJson from "../../shared/MailingMessageJson";
import { MailingMessageStatus, MailingMessageStatusNames } from "../../shared/MailingMessageStatus";
import MailingListJson from "../../shared/MailingListJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "MailingsMessages",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    MailingsMessageDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      MailingMessageStatus: MailingMessageStatus,
      MailingMessageStatusNames: MailingMessageStatusNames,
      showDetails: false,
      detailsMode: "read",
      allMessages: null as MailingMessageJson[] | null,
      messagesMoreAvailable: null as boolean | null,
      selectedMessageId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: MailingMessageJson | null, mode: string) {
      if (item != null) {
        this.selectedMessageId = item.ID;
      } else {
        this.selectedMessageId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllMessages();
    },

    async loadAllMessages(loadMore: null = null) {
      var skipAmount = 0 as number;

      //load more
      if (loadMore && this.allMessages != null) {
        this.messagesMoreAvailable = null;
        skipAmount = this.allMessages.length;
      } else {
        this.allMessages = null;
      }

      //final load recipients
      if (this.restClient != null) {
        try {
          let messages = await this.restClient.getMailingMessages(skipAmount);

          if (loadMore && this.allMessages != null) {
            this.allMessages = this.allMessages.concat(messages.messages);
          } else {
            this.allMessages = messages.messages;
          }

          this.messagesMoreAvailable = messages.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadAllMessages();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    messagesColumns: function (): TableViewColumnDefinitions<MailingMessageJson>[] {
      let vue = this;

      return [
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateTime(new Date(i.broadcastDateTime)),
        },
        {
          th: "Betreff",
          td: (i) => i.subject,
        },
        {
          th: "Status",
          td: (i) => vue.MailingMessageStatusNames[i.state],
        },
      ] as TableViewColumnDefinitions<MailingMessageJson>[];
    },
  },
});
